// Module
var code = "<p>创建自定义资产需要以下信息：</p> <ul> <li>资产符号</li> <li>最大供给量</li> </ul> <p>精度决定了资产支持的小数点后的位数。</p> <p>资产创建需要支付的费用取决于资产符号的字符长度。</p> <p>你可以设定交易手续费率来决定用户交易时需要向你支付多少比例的费用。</p> ";
// Exports
export default code;